import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { MessageCircle, Check } from 'lucide-react';
import { Button } from './ui/button';

const PricingSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const services = [
    { name: 'Lavado Carrocería', price: 'Consultar' },
    { name: 'Lavado de motor', price: 'Consultar' },
    { name: 'Descontaminación de pintura', price: 'Consultar' },
    { name: 'Eliminación de lluvia ácida', price: 'Consultar' },
    { name: 'Encerado', price: 'Consultar' },
    { name: 'Desmanchado de mordazas y estribos', price: 'Consultar' },
    { name: 'Pulida de faros', price: 'Consultar' },
    { name: 'Pulido', price: 'Consultar' },
    { name: 'Limpieza de tapicería', price: 'Consultar' },
    { name: 'Limpieza techo', price: 'Consultar' },
    { name: 'Limpieza de alfombras', price: 'Consultar' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <section id="pricing" className="bg-[#0A1628] py-24 md:py-32 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-40 right-20 w-96 h-96 bg-[#60A5FA] rounded-full filter blur-3xl" />
      </div>

      <motion.div
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        className="max-w-5xl mx-auto px-6 relative z-10"
      >
        {/* Section Number */}
        <motion.div variants={itemVariants} className="mb-8">
          <span className="text-[#60A5FA] text-lg font-mono">03</span>
        </motion.div>

        {/* Section Title */}
        <motion.h2 variants={itemVariants} className="text-5xl md:text-6xl font-bold text-white mb-16">
          Lista de <span className="text-[#60A5FA]">Precios</span>
        </motion.h2>

        {/* Pricing Table */}
        <motion.div
          variants={itemVariants}
          className="bg-[#0F1D33]/50 backdrop-blur-lg border border-white/10 rounded-3xl p-8 md:p-12"
        >
          <div className="space-y-4">
            {services.map((service, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ x: 8, transition: { duration: 0.2 } }}
                className="flex items-center justify-between py-4 border-b border-white/10 last:border-0 group"
              >
                <div className="flex items-center space-x-4">
                  <div className="w-6 h-6 bg-[#60A5FA]/20 rounded-full flex items-center justify-center group-hover:bg-[#60A5FA]/40 transition-colors duration-300">
                    <Check className="w-4 h-4 text-[#60A5FA]" />
                  </div>
                  <span className="text-white text-lg">{service.name}</span>
                </div>
                <span className="text-[#60A5FA] font-semibold text-lg">{service.price}</span>
              </motion.div>
            ))}
          </div>

          {/* CTA */}
          <motion.div variants={itemVariants} className="mt-12 text-center">
            <p className="text-white/70 mb-6 text-lg">
              Contacta con nosotros para obtener información detallada sobre nuestros precios
            </p>
            <Button
              size="lg"
              className="bg-[#60A5FA] text-white hover:bg-[#3B82F6] text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
              onClick={() => window.open('https://wa.me/593958646225', '_blank')}
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              Solicitar información
            </Button>
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default PricingSection;
